var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    viewBox: "0 0 11 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.950577 7.8846L7.99708 0.838136C8.33693 0.498291 8.8879 0.498291 9.22771 0.838136L10.0496 1.65999C10.3888 1.99926 10.3895 2.54911 10.051 2.88917L4.46654 8.49994L10.051 14.1107C10.3895 14.4507 10.3888 15.0006 10.0496 15.3398L9.22771 16.1617C8.88786 16.5015 8.33689 16.5015 7.99708 16.1617L0.950577 9.11527C0.610768 8.77542 0.610768 8.22445 0.950577 7.8846Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.00aa3bd22dd0b2b8984fc173c6ad7f36.svg";
export { ForwardRef as ReactComponent };